import React from 'react';
import AvailableComponentLists from '../../utils/AvailableComponentLists';
import './../../Canvas.scss';
import { useSelector } from 'react-redux';
import { selectedPage } from '../../redux/selectedPageSlice';
import { allPages, selectPageById } from '../../redux/pagesSlice';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import { findCompByIdRecursively } from '../../utils/functions';
import SelectableCssVariablesImport from './SelectableCssVariables/SelectableCssVariablesImport';
import { specialComponents } from '../../utils/functions';

const y300Grab = { bg: 'yellow.300', borderColor: 'yellow.300', cursor: 'grab' };
const y400 = { bg: 'yellow.400', borderColor: 'yellow.400' };

const VtexStoreComponent = ({ componentName, componentId, props, children, blocks }) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	if (!componentName) {
		return console.error(`Componente nao encontrado`);
	} else {
		return AvailableComponentLists(componentName, props, children, blocks, selectedCanvasResolution, null, componentId);
	}
};

//Textos editáveis como HTML (Quill), apenas trocando espaços por NBSP para quando convertermos usando o showdown não dê problema
//também trimmar os \n do Quill na hora de transformar para markdown
const VtexFixedComponentWM = ({ comp, componentId, componentGroup }) => {
	const pageId = useSelector(selectedPage);
	const pages = useSelector(allPages);
	// const selectedComponentValue = useSelect(selectedComponent)
	const [compProps, setCompProps] = React.useState(comp);

	React.useEffect(() => {
		const spc = specialComponents[componentGroup];
		if (spc && pageId !== spc) {
			const page = pages.find((page) => page.pageId == spc);
			if (page) {
				const { comp } = findCompByIdRecursively(page.pageData, componentId);
				if (comp) {
					setCompProps(comp);
				} else {
					const foundCompByName = page.pageData.find((comp) => componentGroup == comp.componentGroup);
					if (foundCompByName) {
						setCompProps(foundCompByName);
					} else {
						setCompProps(page.pageData[0]);
					}
				}
			}
		} else if (spc) {
			setCompProps(null);
		} else if (comp) {
			if (JSON.stringify(compProps) != JSON.stringify(comp)) {
				setCompProps(comp);
			}
		}
	}, [comp, componentId]);

	if (!compProps || !compProps.componentName) {
		return null;
	}
	return (
		<>
			{compProps?.variables && <SelectableCssVariablesImport component={compProps} variables={compProps.variables} />}
			<VtexStoreComponent
				{...compProps}
				blocks={
					compProps.blocks &&
					compProps.blocks.map((block) => (
						<VtexFixedComponent
							key={`vtex-fixed-block-component-${block.componentId}`}
							{...{
								comp: block,
								componentId: block.componentId,
								componentGroup: block?.componentGroup || componentGroup,
							}}
						/>
					))
				}
			>
				{((compProps && compProps.childrenComponents) || []).map((childEl, index, arr) => {
					return (
						<VtexFixedComponent
							key={`vtex-fixed-component-${childEl.componentId}`}
							className="VtexComponent"
							{...{
								componentId: childEl.componentId,
								componentGroup: childEl?.componentGroup || componentGroup,
								comp: childEl,
							}}
						/>
					);
				})}
			</VtexStoreComponent>
		</>
	);
};

const VtexFixedComponent = React.memo(VtexFixedComponentWM);
export default VtexFixedComponent;
